import { apiSlice } from "./apiSlice";
import { USERS_URL } from "../constants";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth`,
        method: "POST",
        body: data,
      }),
    }),

    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}`,
        method: "POST",
        body: data,
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: "POST",
      }),
    }),

    profile: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/profile`,
        method: "PUT",
        body: data,
      }),
    }),
    
    getProfile: builder.query({
      query: () => ({
        url: `${USERS_URL}/profile`,
        
      }),
      providesTags: ["User"],
      keepUnusedDataFor: 5,
    }),
    getVendors: builder.query({
      query: () => ({
        url: `${USERS_URL}/vendors`,
        
      }),
      providesTags: ["User"],
      keepUnusedDataFor: 5,
    }),

    getUsers: builder.query({
      query: () => ({
        url: USERS_URL,
      }),
      providesTags: ["User"],
      keepUnusedDataFor: 5,
    }),

    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
        method: "DELETE",
      }),
    }),

    getUserDetails: builder.query({
      query: (id) => ({
        url: `${USERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/${data.userId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
    

    // Reset password with OTP
    resetPassword: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/reset-password`,
        method: 'POST',
        body: data,
      }),
    }),
        getAreas: builder.query({
      query: () => ({
        url: `${USERS_URL}/misc/areas`,
        method: 'GET',
      }),
    }),
 

    // ✅ Updated endpoint name and route for address updates
    updateUserAddresses: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/addresses`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useProfileMutation,
  useGetUsersQuery,
  useGetProfileQuery,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useGetUserDetailsQuery,
  useUpdateUserAddressesMutation,
  useResetPasswordMutation,
  useGetVendorsQuery,
  useGetAreasQuery,
} = userApiSlice;
